module.exports = __webpack_public_path__ + "static/media/reposted.7bdfb22c.svg";